import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance } from 'vue'
import TabRail from '@/components/TabRail.vue'
import EmailTab from './EmailTab.vue'
import SmsTab from './SMSTab.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessagingLogs',
  setup(__props) {

// Messages: one page, one tab per channel, each opening on a by-customer view with the
// per-message log behind the Every message filter toggle. Each tab owns its own filters,
// paging and drawer; the tab rides in the URL so a link opens the right one.
const { proxy } = getCurrentInstance() as any

const tabs = [
  { name: 'Email', shortName: 'Email' },
  { name: 'SMS', shortName: 'SMS' }
]
const activeTab = ref(0)
// Bumped by the New message button beside the tabs; the SMS tab opens the composer on each bump
const newMessageSignal = ref(0)

function switchTab(index: number) {
  if (index === activeTab.value) return
  activeTab.value = index
  // Each tab keeps its own page and per-page in the query; drop them on a switch
  proxy.$router.replace({ path: proxy.$route.path, query: { tab: index === 1 ? 'sms' : 'email' } }).catch(() => {})
}

onMounted(() => {
  activeTab.value = proxy.$route.query.tab === 'sms' ? 1 : 0
  // The saved views drawer tells the two tabs apart by this query, so it is always present
  if (!proxy.$route.query.tab) {
    proxy.$router.replace({ path: proxy.$route.path, query: { ...proxy.$route.query, tab: 'email' } }).catch(() => {})
  }
})

return { __sfc: true,proxy, tabs, activeTab, newMessageSignal, switchTab, TabRail, EmailTab, SmsTab }
}

})